import { Component, EventEmitter, Input, OnInit, Output, PLATFORM_ID, Inject } from '@angular/core';
import { Tenure } from 'src/app/core/models/car.model';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { AppConstants } from 'src/app/core/constants';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { Options } from '@angular-slider/ngx-slider';
import { isPlatformBrowser } from '@angular/common';

const defaultOption: Options = {
  floor: 0,
  ceil: 0,
  showTicks: false,
  showTicksValues: false,
  showSelectionBar: true,
  getSelectionBarColor: () => '#ed224d',
};

@Component({
  selector: 'app-price-calculator[tenures]',
  templateUrl: './price-calculator.component.html',
  styleUrls: ['./price-calculator.component.scss',],
})
export class PriceCalculatorComponent implements OnInit {

  value: number = AppConstants.ZERO;

  mileageOption: Options = defaultOption;
  tenureOption: Options = defaultOption;

  @Input() tenures!: Tenure[];
  @Output() tenureChanged = new EventEmitter<number>();
  @Output() mileageChanged = new EventEmitter<number>();

  isBrowser: boolean;
  faArrowRight = faArrowRight;
  tenureOptions: number[] = [];
  tenureMin: number = AppConstants.ZERO;
  tenureMax: number = AppConstants.ZERO;

  mileageOptions: number[] = [];
  mileageMin: number = AppConstants.ZERO;
  mileageMax: number = AppConstants.ZERO;

  originalPrice: number = AppConstants.ZERO;
  discountedPrice: number = AppConstants.ZERO;

  priceCalculatorForm = new UntypedFormGroup({
    mileage: new UntypedFormControl(AppConstants.ZERO),
    tenure: new UntypedFormControl(AppConstants.ZERO),
  });

  constructor(
    private _router: Router,
    @Inject(PLATFORM_ID) private readonly platformId: Object
  ) { 
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit(): void {
    this.calculateTenure();
  }

  getSelectedTenure() {
    const { tenure, } = this.priceCalculatorForm.getRawValue();
    return this.tenureOptions[tenure];
  }

  getSelectedMileage() {
    const { mileage, } = this.priceCalculatorForm.getRawValue();
    return this.mileageOptions[mileage];
  }

  calculateTenure() {
    this.tenureOptions = this.tenures.map(t => t.tenure).sort((a, b) => a - b);
    this.tenureMax = this.tenureOptions.length - AppConstants.ONE;
    // If first time - Select max tenure and min mileage
    if (!this.mileageOptions.length) this.priceCalculatorForm.patchValue({ tenure: this.tenureMax, });
    this.tenureOption = {
      ...this.tenureOption,
      ticksArray: this.tenureOptions,
      ceil: this.tenureMax,
    };
    this.calculateMileage();
  }

  calculateMileage() {
    this.mileageOptions = this.tenures
      .find(t => t.tenure === this.getSelectedTenure())?.mileageOptions
      .map(m => m.mileage).sort((a, b) => a - b) || [];
    this.mileageMax = this.mileageOptions.length - AppConstants.ONE;
    this.mileageOption = {
      ...this.mileageOption,
      ticksArray: this.mileageOptions,
      ceil: this.mileageMax,
    };
    this.calculatePrice();
  }

  calculatePrice() {
    const mileage = this.getSelectedMileage();
    const tenure = this.getSelectedTenure();
    const tenureMilage = this.tenures
      .find(t => t.tenure === tenure)?.mileageOptions
      .find(m => m.mileage === mileage);
    this.discountedPrice = tenureMilage?.displayPrice || AppConstants.ZERO;
    this.originalPrice = tenureMilage?.amount || AppConstants.ZERO;

    // Emit data for subscription
    this.mileageChanged.emit(mileage);
    this.tenureChanged.emit(tenure);
  }

  navigateTo(path: string) {
    this._router.navigateByUrl(path);
  }

  onTenureChange(index: number) {
    this.priceCalculatorForm.patchValue({ tenure: index, });
    this.calculateTenure();
  }

  onMileageChange(index: number) {
    this.priceCalculatorForm.patchValue({ mileage: index, });
    this.calculateMileage();
  }

}
